import { Resources } from './resources'
import { templateUserId } from '../constants/index'

class MagazinesResource extends Resources {
  uploadFile ( id, formData ) {
    return this.http.post( `${this.baseUrl}/${id}/uploads`, formData )
  }

  getPages ( id ) {
    return this.http.get( `${this.baseUrl}/${id}/pages` )
  }

  getPagesForPreview ( id ) {
    return this.http.get( `${this.baseUrl}/${id}/pages?userId=${templateUserId}` )
  }

  getTemplates () {
    return this.http.get( `${this.baseUrl}?templates=true&id=${templateUserId}` )
  }

  clone ( id, payload ) {
    return this.http.post( `${this.baseUrl}/${id}/clone`, payload )
  }
}

export default new MagazinesResource( 'magazines' )


// WEBPACK FOOTER //
// ./src/resources/magazines.js